"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateEditableTextLayer;
const EditableTextLayer_1 = require("../../../models/layers/EditableTextLayer");
const Printable_1 = require("../../../models/printables/Printable");
const either_1 = require("../../../types/either");
const unfoldProject_1 = __importDefault(require("./helpers/unfoldProject"));
const assertSizeOrPositionUpdateIsValid_1 = __importDefault(require("./helpers/assertSizeOrPositionUpdateIsValid"));
function updateEditableTextLayer(project, action) {
  var _a;
  const maybeUnfoldedProject = (0, unfoldProject_1.default)(project, action.printableId, action.layerId);
  if (maybeUnfoldedProject.isLeft()) {
    return (0, either_1.left)(maybeUnfoldedProject.value);
  }
  const {
    printable,
    layer
  } = maybeUnfoldedProject.value;
  const layerUpdates = action.layerUpdates;
  (0, Printable_1.mutablyUpdatePrintableVersion)(printable, action.timestamp);
  const isSizeOrPositionUpdateValid = (0, assertSizeOrPositionUpdateIsValid_1.default)(layer, layerUpdates);
  if (isSizeOrPositionUpdateValid.isLeft()) {
    return (0, either_1.left)(isSizeOrPositionUpdateValid.value);
  }
  Object.assign(layer, layerUpdates);
  if ((_a = layer.userData) === null || _a === void 0 ? void 0 : _a.content) {
    layer.userData.assetId = (0, EditableTextLayer_1.generateTextAssetId)(layer.width, layer.height, layer.userData.content, printable.surface);
  }
  const updatedEntities = [printable, project];
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: updatedEntities
  });
}